module.exports = __webpack_public_path__ + "assets/img/title-200ebf75.png";